import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

const GlobeSkeleton = () => {
  const meshRef = useRef();

  useFrame((state) => {
    if (meshRef.current) {
      meshRef.current.rotation.y = state.clock.elapsedTime * 0.5;
    }
  });

  return (
    <mesh ref={meshRef}>
      <sphereGeometry args={[100, 16, 16]} /> {/* Low res for speed */}
      <meshBasicMaterial color="lightblue" wireframe opacity={0.5} transparent />
    </mesh>
  );
};

export default GlobeSkeleton;